import * as React from 'react';
import DialogTitle from '@mui/material/DialogTitle';
import Dialog from '@mui/material/Dialog';
import { Box, Button, DialogActions, DialogContent, DialogContentText, SxProps } from '@mui/material';

interface Props {
    showDialog: boolean
    cancelNavigation: any
    confirmNavigation: any
}

const ConfirmDiscardChanges = ({ showDialog, cancelNavigation, confirmNavigation }: Props) => {
    const handleClose = (event: {}, reason: "backdropClick" | "escapeKeyDown") => {
        if (reason === "backdropClick") return;

        cancelNavigation();
    };

    return (
        <Dialog onClose={handleClose} open={showDialog} fullWidth maxWidth='sm' disableEscapeKeyDown >
            <DialogTitle id="alert-dialog-title">
                Unsaved changes?
            </DialogTitle>
            <DialogContent>
                <DialogContentText id="alert-dialog-description">
                    You have unsaved changes. Do you want to continue?
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button size="small" variant="contained" onClick={confirmNavigation}>Continue</Button>
                <Button size="small" variant="contained" onClick={cancelNavigation}>Cancel</Button>
            </DialogActions>
        </Dialog>
    );
}

export { ConfirmDiscardChanges }
export default ConfirmDiscardChanges;